import React, { ReactElement } from 'react';
import classNames from 'classnames';

import styles from './messageInput.module.scss';
import CustomIcon from '@/components/ui/CustomIcon';

type Props = {
  onSend: (message: string) => void;
  enabled: boolean;
  placeholder?: string;
};

const MessageInput = (props: Props): ReactElement => {
  const [content, setContent] = React.useState<string>('');

  const handleSend = (): void => {
    if (!props.enabled || !content.trim()) {
      return;
    }

    props.onSend(content.trim());
    setContent('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  return (
    <div className={styles['input-container']}>
      <div className={styles['message-input']}>
        <input
          className={styles['text-input']}
          type="text"
          placeholder={props.placeholder}
          value={content}
          onChange={e => setContent(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          onClick={handleSend}
          className={classNames(styles['send-button'], {
            [styles.active]: content.trim().length > 0 && props.enabled,
          })}
        >
          <div className={styles['send-icon-wrapper']}>
            <CustomIcon name="send" width={20} height={20} />
          </div>
        </button>
      </div>
      <div className={styles['ai-disclaimer']}>
        Contenido generado por IA.
      </div>
    </div>
  );
};

export default MessageInput;
